import { useHistory } from 'react-router-dom';

import Grid2 from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';

import { groceryListIdSelector } from '../../app/groceryList/groceryList.slice';
import useLogRecipeEdit from '../../hooks/useLogRecipeEdit';
import { RightArrow, ShoppingBag } from '../../iconRef/mealPLanIcons';
import { EventLogsEnum } from '../../utils/events';
import styles from "./viewGroceryListCard.module.css";
import { useAppSelector } from '../../app/store/hooks';
import { GroceryList } from '../../app/commonSelector';
import { SelectedDateSelector } from '../../app/mealPlan/mealPlan.slice';

const ViewGroceryListCard = () => {
    const history = useHistory();
    const { logRecipeEdit } = useLogRecipeEdit();
    const groceryListId = useAppSelector(groceryListIdSelector);
    const handleRightArrowClick = () => {
        logRecipeEdit(EventLogsEnum.VIEW_GROCERY_LIST
            , {
                eventData: {
                    list_id: groceryListId,

                },
            });

        const url = `/grocery-list`;
        history.push(url);
    }



    return (
        <Grid2 className={styles.grocery_button_container} onClick={handleRightArrowClick}>
            <ShoppingBag />
            <Grid2 className={styles.second_grid}>
                <Typography variant='caption3Bold'>Grocery List (7 days)</Typography>
                {/* <RightArrow /> */}
            </Grid2>
        </Grid2>
    )
}

export default ViewGroceryListCard
